export const nav = {
  home: 'ホーム',
  about: '会社概要',
  services: 'サービス',
  gallery: 'ギャラリー',
  contact: 'お問い合わせ',
  book: '予約する',
  logout: 'ログアウト',
  admin: '予約一覧',
};

export const hero = {
  headline: "N's Group Ltd. — 信頼できるコンテナバンニングソリューション グローバル車両輸出のために",
  subheadline: '自動車、トラック、機械輸出のためのプロフェッショナルなコンテナ積込サービス',
  requestQuote: '見積もり依頼',
  contactUs: 'お問い合わせ',
};

export const about = {
  label: "N'Sグループについて",
  headline1: '信頼できるパートナー',
  headline2: '車両輸出',
  headline3: 'ロジスティクス',
  paragraph1: "N's Group Ltd.は、車両輸出のためのプロフェッショナルなコンテナバンニングサービスを提供する大手企業です。物流業界での長年の経験を持ち、自動車、トラック、重機、自動車部品の輸送コンテナへの安全で効率的な積込を専門としています。",
  paragraph2: '経験豊富なプロフェッショナルチームが、積込プロセス中にすべての車両が適切に固定され保護されることを保証します。輸出業者、貿易会社、フォワーダーと緊密に協力し、国際輸送基準を満たす信頼性の高いコンテナ積込作業を提供します。',
  learnMore: '詳細を見る',
};

export const services = {
  label: '私たちのサービス',
  headline1: '完全なコンテナ',
  headline2: 'バンニングソリューション',
  subtitle: 'グローバル車両輸出に合わせたプロフェッショナルな積込サービス',
  service1: {
    title: 'コンテナバンニング',
    items: [
      'プロフェッショナルな車両積込',
      '安全なコンテナ梱包',
      '品質検査',
      '積込書類作成',
    ],
  },
  service2: {
    title: '車両輸出ロジスティクス',
    items: [
      '輸出調整',
      '税関書類',
      '配送手配',
      '物流サポート',
    ],
  },
  service3: {
    title: '重機積込',
    items: [
      '機械積込',
      'トラック積込サービス',
      '機器固定',
      '特殊取扱い',
    ],
  },
  service4: {
    title: 'スペース最適化',
    items: [
      'コンテナスペース計画',
      '最大積載効率',
      'コスト最適化',
      '積載計算',
    ],
  },
  service5: {
    title: '貨物固定',
    items: [
      'プロフェッショナルな固定方法',
      '損傷防止',
      '安全コンプライアンス',
      '保護材料',
    ],
  },
  service6: {
    title: '輸出書類',
    items: [
      '積込報告書',
      '写真記録',
      '証明書発行',
      'コンプライアンス記録',
    ],
  },
};

export const industries = {
  label: 'サポートする業界',
  headline1: 'グローバル輸出',
  headline2: '市場へのサービス',
  industry1: {
    title: '中古車輸出業者',
    description: '世界中の中古車輸出ビジネスのためのプロフェッショナルなコンテナ積込サービス。',
  },
  industry2: {
    title: '自動車貿易',
    description: '信頼性の高いバンニング作業で国際自動車貿易会社をサポート。',
  },
  industry3: {
    title: '機械輸出業者',
    description: '重機および建設機械輸出のための専門的な積込サービス。',
  },
  industry4: {
    title: 'フォワーダー',
    description: 'シームレスなコンテナ積込サービスのためのフォワーディング会社とのパートナーシップ。',
  },
};

export const whyChoose = {
  label: '選ばれる理由',
  headline1: '経験が',
  headline2: '卓越性と',
  headline3: '出会う',
  paragraph: "車両輸出ロジスティクスにおける長年の専門知識により、N's Group Ltd.は、貨物が安全かつ効率的に目的地に到着することを保証するプロフェッショナルなコンテナバンニングサービスを提供します。",
  viewProcess: 'プロセスを見る',
  feature1: {
    title: '経験豊富なプロフェッショナル',
    description: '熟練したチームは、コンテナ積込作業と車両輸出ロジスティクスにおいて豊富な経験を持っています。',
  },
  feature2: {
    title: '安全な貨物取扱い',
    description: 'すべての出荷において、適切な固定方法と損傷防止技術で安全を優先します。',
  },
  feature3: {
    title: '効率的な作業',
    description: '合理化されたプロセスと最適化されたワークフローにより、輸出の迅速な処理時間を保証します。',
  },
  feature4: {
    title: '迅速な処理',
    description: 'タイトな配送スケジュールと締め切りに対応する迅速で信頼性の高いサービス提供。',
  },
};

export const process = {
  label: '仕組み',
  headline: 'シンプルな5ステッププロセス',
  step1: {
    title: 'お問い合わせと見積もり',
    description: '車両輸出要件についてお問い合わせいただき、コンテナバンニングサービスの詳細な見積もりを受け取ります。',
  },
  step2: {
    title: '予約確認',
    description: '予約を確認し、輸出スケジュールに最適なコンテナ積込日を予定します。',
  },
  step3: {
    title: '車両到着',
    description: '車両を当社施設に配送し、チームが検査してコンテナ積込の準備をします。',
  },
  step4: {
    title: 'コンテナ積込',
    description: '経験豊富なプロフェッショナルが、適切な技術を使用してコンテナ内に車両を慎重に積込み固定します。',
  },
  step5: {
    title: '輸出準備完了',
    description: '積込書類と写真を受け取ります。コンテナは目的地への出荷準備が整いました。',
  },
};

export const testimonials = {
  label: 'お客様の声',
  headline1: '世界中の輸出業者から',
  headline2: '信頼されています',
  subtitle: 'コンテナバンニングサービスについてのお客様の声をご覧ください',
  review1: {
    headline: 'プロフェッショナルで信頼できるサービス',
    text: "N's Groupは3年以上にわたり、コンテナ積込の信頼できるパートナーです。チームはプロフェッショナルで効率的、常に時間通りに配送します。車両輸出ロジスティクスに強くお勧めします。",
    name: 'マイケル・チェン',
    company: 'グローバルオート貿易株式会社',
  },
  review2: {
    headline: '優れたコンテナ積込',
    text: 'コンテナバンニングサービスの品質は素晴らしいです。すべての車両が完璧な状態で目的地に到着します。細部への注意と貨物固定方法は一流です。',
    name: 'サラ・ジョンソン',
    company: 'インターナショナルモーターズ株式会社',
  },
  review3: {
    headline: '迅速で効率的な作業',
    text: "毎月数百台の車両を輸出していますが、N's Groupは印象的なスピードと効率でコンテナ積込を処理します。チームは経験豊富で非常にプロフェッショナルです。",
    name: '山本武',
    company: 'パシフィック輸出ソリューションズ',
  },
  review4: {
    headline: '優れたコミュニケーション',
    text: 'プロセス全体を通じてコミュニケーションが優れています。詳細な積込報告書と写真を提供してくれるので、サービス品質に自信が持てます。',
    name: 'デビッド・マルティネス',
    company: 'ユーロアジアロジスティクス',
  },
  review5: {
    headline: 'コスト効果的なソリューション',
    text: 'スペース最適化の専門知識により、コンテナ容量を最大化し、配送コストを削減できます。プロフェッショナルなコンテナバンニングサービスに対する優れた価値。',
    name: 'リサ・アンダーソン',
    company: 'ワールドワイド車両輸出',
  },
  review6: {
    headline: '信頼できる長期パートナー',
    text: "N's Groupと長年協力しており、常に優れたサービスを提供しています。信頼性とプロフェッショナリズムにより、当社の優先コンテナ積込パートナーとなっています。",
    name: '田中浩',
    company: '東京オート輸出株式会社',
  },
};

export const gallery = {
  label: 'ギャラリー',
  headline: '私たちの仕事',
  viewFull: 'フルギャラリーを見る',
};

export const cta = {
  headline: '輸出準備はできていますか？',
  description1: 'プロフェッショナルなコンテナバンニングサービスを取得',
  description2: '今すぐカスタム見積もりについてお問い合わせください',
  button: '今すぐ見積もり依頼',
};

export const contact = {
  label: 'お問い合わせ',
  headline: '見積もりをリクエスト',
  form: {
    name: 'お名前',
    company: '会社名',
    email: 'メールアドレス',
    phone: '電話番号',
    message: 'メッセージ',
    submit: 'お問い合わせを送信',
    namePlaceholder: 'お名前を入力してください',
    companyPlaceholder: '会社名を入力してください',
    emailPlaceholder: 'your@email.com',
    phonePlaceholder: '+81 90-3138-4477',
    messagePlaceholder: 'コンテナバンニング要件についてお聞かせください...',
  },
  info: {
    location: '本社',
    address1: 'ダイヤパレス御徒町3 – 505',
    address2: '東上野3-5-10、台東区',
    address3: '東京都 110-0016',
    yard: 'ヤード / 作業拠点',
    yardAddress1: '茨城県猿島郡境町',
    yardAddress2: '伏木2964-1',
    yardAddress3: '〒306-0416',
    contact: '電話とメール',
    phone: '+81-90-3138-4477',
    email: 'info@nsgroupltd.com',
    hours: '営業時間',
    hoursText: '月曜日 - 金曜日: 9:00 AM - 6:00 PM',
    hoursText2: '土曜日: 9:00 AM - 1:00 PM',
  },
};

export const footer = {
  brand: "N'S GROUP LTD.",
  description: 'グローバル車両輸出のためのプロフェッショナルなコンテナバンニングソリューション。世界中の輸出業者に自動車、トラック、重機、自動車部品の信頼できるコンテナ積込サービスを提供します。',
  quickLinks: 'クイックリンク',
  contactInfo: '連絡先情報',
  addressLabel: '本社',
  yardLabel: 'ヤード / 作業拠点',
  phoneLabel: '電話',
  emailLabel: 'メール',
  copyright: "© 2025 N's Group Ltd. All rights reserved.",
  privacy: 'プライバシーポリシー',
  terms: '利用規約',
  sitemap: 'サイトマップ',
};

export const book = {
  badge: "N's Group Ltd. — オンライン予約",
  hero_title: 'ご予約メニュー',
  hero_subtitle: '配送・積込・フォワーディングの3種類の予約サービスをご用意しています。\nご希望のサービスをお選びください。',
  section_label: 'Our Services',
  section_title: 'サービスを選択してください',
  section_subtitle: '各サービスの詳細をご確認の上、ご希望の予約フォームへお進みください。',
  btn_form: 'フォームへ',
  info_yard: 'ヤード / 作業拠点',
  info_yard_address: '茨城県猿島郡境町 伏木2964-1 〒306-0416',
  info_hours: '営業時間',
  info_hours_text: '月〜金：9:00 AM – 6:00 PM\n土曜日：9:00 AM – 1:00 PM',
  info_phone: 'お電話でのご予約',
  services: {
    shipping: {
      label: 'SHIPPING APPOINTMENT',
      title: '配送予約',
      subtitle: 'Shipping Appointment',
      description: 'コンテナバンニングの予約をオンラインで簡単にお申し込みいただけます。貨物の種類・台数・希望日程をご入力ください。',
      features: ['乗用車・トラック・重機', 'コンテナサイズ選択', 'CY締め切り日管理', '希望時間帯指定'],
    },
    loading: {
      label: 'LOADING APPOINTMENT',
      title: '積込予約',
      subtitle: 'Loading Appointment',
      description: 'コンテナへの積込作業のご予約をオンラインで簡単にお申し込みいただけます。積込方法・場所・日程をご指定ください。',
      features: ['フォークリフト・クレーン対応', 'コンテナ番号管理', '積込場所の選択', 'RoRo・手積み対応'],
    },
    forwarding: {
      label: 'FORWARDING APPOINTMENT',
      title: 'フォワーディング予約',
      subtitle: 'Forwarding Appointment',
      description: '国際輸送・通関手続きのご相談・予約をオンラインで受け付けています。輸送ルート・書類手配まで一括サポートします。',
      features: ['海上・航空輸送対応', '通関手続きサポート', 'インコタームズ対応', '世界各地へ輸送'],
    },
  },
};

export const appointment = {
  badge: 'SHIPPING APPOINTMENT',
  hero_title: '配送予約フォーム',
  hero_subtitle: 'コンテナバンニングの予約をオンラインで簡単にお申し込みいただけます。\n必要事項をご入力の上、送信してください。',
  sec1_title: 'お客様情報',
  sec2_title: '積込内容',
  sec3_title: '希望日程',
  sec4_title: '備考・その他',
  field_name: 'お名前',
  field_company: '会社名',
  field_email: 'メールアドレス',
  field_phone: '電話番号',
  field_cargo_type: '貨物の種類',
  field_quantity: '台数 / 数量',
  field_container_size: 'コンテナサイズ',
  field_destination: '仕向地（輸出先）',
  field_preferred_date: '希望積込日',
  field_alt_date: '第2希望日',
  field_preferred_time: '希望時間帯',
  field_cy_cutoff: '船積み予定日（CY締め切り）',
  field_notes: 'ご要望・特記事項',
  placeholder_name: '山田 太郎',
  placeholder_company: '株式会社〇〇',
  placeholder_quantity: '例：3',
  placeholder_destination: '例：ドバイ、UAE',
  placeholder_notes: '特別な取扱いが必要な場合や、ご不明な点などをご記入ください...',
  opt_select: '選択してください',
  opt_unspecified: '未定 / ご相談',
  opt_no_pref: '指定なし',
  opt_morning: '午前（9:00〜12:00）',
  opt_afternoon: '午後（13:00〜17:00）',
  cargo_passenger: '乗用車',
  cargo_truck: 'トラック・商用車',
  cargo_heavy: '重機・建設機械',
  cargo_motorcycle: 'バイク・二輪車',
  cargo_parts: '自動車部品',
  cargo_other: 'その他',
  container_20: '20フィートコンテナ',
  container_40: '40フィートコンテナ',
  container_40hc: '40フィートHCコンテナ',
  container_45: '45フィートコンテナ',
  submit: '予約を申し込む',
  submitting: '送信中...',
  new_booking: '新しい予約をする',
  success_title: '予約を受け付けました',
  success_msg: 'ご予約内容を確認の上、担当者よりご連絡いたします。\n通常1〜2営業日以内にご返信いたします。',
  required_note: '* は必須項目です。ご予約確認後、担当者よりご連絡いたします（1〜2営業日）。',
  info_yard: 'ヤード / 作業拠点',
  info_hours: '営業時間',
  info_phone: 'お電話でのご予約',
};

export const loading = {
  badge: 'LOADING APPOINTMENT',
  hero_title: '積込予約フォーム',
  hero_subtitle: 'コンテナへの積込作業のご予約をオンラインで簡単にお申し込みいただけます。\n必要事項をご入力の上、送信してください。',
  sec1_title: 'お客様情報',
  sec2_title: '積込内容',
  sec3_title: '希望日程',
  sec4_title: '備考・その他',
  field_name: 'お名前',
  field_company: '会社名',
  field_email: 'メールアドレス',
  field_phone: '電話番号',
  field_cargo_type: '積込品目',
  field_quantity: '台数 / 数量',
  field_container_size: 'コンテナサイズ',
  field_container_number: 'コンテナ番号',
  field_destination: '仕向地（輸出先）',
  field_loading_method: '積込方法',
  field_preferred_date: '希望積込日',
  field_alt_date: '第2希望日',
  field_preferred_time: '希望時間帯',
  field_cy_cutoff: 'CY搬入締め切り日',
  field_etd: '船積み予定日',
  field_loading_location: '積込場所',
  field_notes: 'ご要望・特記事項',
  placeholder_name: '山田 太郎',
  placeholder_company: '株式会社〇〇',
  placeholder_quantity: '例：3',
  placeholder_container_number: '例：ABCU1234567',
  placeholder_destination: '例：ドバイ、UAE',
  placeholder_notes: '特別な取扱いが必要な場合や、ご不明な点などをご記入ください...',
  opt_select: '選択してください',
  opt_unspecified: '未定 / ご相談',
  opt_no_pref: '指定なし',
  opt_morning: '午前（9:00〜12:00）',
  opt_afternoon: '午後（13:00〜17:00）',
  cargo_passenger: '乗用車',
  cargo_truck: 'トラック・商用車',
  cargo_heavy: '重機・建設機械',
  cargo_motorcycle: 'バイク・二輪車',
  cargo_parts: '自動車部品',
  cargo_general: '一般貨物',
  cargo_other: 'その他',
  container_20: '20フィートコンテナ',
  container_40: '40フィートコンテナ',
  container_40hc: '40フィートHCコンテナ',
  container_45: '45フィートコンテナ',
  method_roro: 'RoRo（自走）',
  method_forklift: 'フォークリフト',
  method_crane: 'クレーン',
  method_manual: '手積み',
  location_yard: '弊社ヤード（境町）',
  location_port: '港湾施設',
  location_customer: 'お客様指定場所',
  submit: '予約を申し込む',
  submitting: '送信中...',
  new_booking: '新しい予約をする',
  success_title: '予約を受け付けました',
  success_msg: 'ご予約内容を確認の上、担当者よりご連絡いたします。\n通常1〜2営業日以内にご返信いたします。',
  required_note: '* は必須項目です。ご予約確認後、担当者よりご連絡いたします（1〜2営業日）。',
  info_yard: 'ヤード / 作業拠点',
  info_hours: '営業時間',
  info_phone: 'お電話でのご予約',
};

export const forwarding = {
  badge: 'FORWARDING APPOINTMENT',
  hero_title: 'フォワーディング予約フォーム',
  hero_subtitle: '国際輸送・通関手続きのご相談・予約をオンラインで簡単にお申し込みいただけます。\n必要事項をご入力の上、送信してください。',
  sec1_title: 'お客様情報',
  sec2_title: '輸送・貨物情報',
  sec3_title: '通関・書類情報',
  sec4_title: '備考・その他',
  field_name: 'お名前',
  field_company: '会社名',
  field_email: 'メールアドレス',
  field_phone: '電話番号',
  field_service_type: '輸送サービス種別',
  field_cargo_type: '貨物の種類',
  field_quantity: '台数 / 数量',
  field_weight: '概算重量（kg）',
  field_pol: '積出港（出発地）',
  field_pod: '仕向港（目的地）',
  field_customs: '通関手続き',
  field_incoterms: 'インコタームズ',
  field_preferred_date: '希望出荷日',
  field_preferred_arrival: '希望到着日（目安）',
  field_docs: '必要書類（複数選択可）',
  field_notes: 'ご要望・特記事項',
  placeholder_name: '山田 太郎',
  placeholder_company: '株式会社〇〇',
  placeholder_quantity: '例：3',
  placeholder_weight: '例：5000',
  placeholder_pol: '例：東京港、横浜港',
  placeholder_pod: '例：ドバイ港、UAE',
  placeholder_notes: '特別な取扱いが必要な場合、危険物の詳細、その他ご不明な点などをご記入ください...',
  opt_select: '選択してください',
  opt_unspecified: '未定 / ご相談',
  opt_consult: '要相談',
  service_sea_fcl: '海上輸送（FCL）',
  service_sea_lcl: '海上輸送（LCL）',
  service_air: '航空輸送',
  service_multi: '複合輸送',
  service_customs: '通関手続きのみ',
  service_consult: '輸送相談・見積もり',
  cargo_passenger: '乗用車',
  cargo_truck: 'トラック・商用車',
  cargo_heavy: '重機・建設機械',
  cargo_motorcycle: 'バイク・二輪車',
  cargo_parts: '自動車部品',
  cargo_general: '一般貨物',
  cargo_hazardous: '危険物・特殊貨物',
  cargo_other: 'その他',
  customs_export: '輸出通関のみ',
  customs_import: '輸入通関のみ',
  customs_both: '輸出・輸入両方',
  customs_none: '不要',
  customs_consult: '要相談',
  doc_bl: '船荷証券（B/L）',
  doc_invoice: 'インボイス',
  doc_packing: 'パッキングリスト',
  doc_origin: '原産地証明書',
  doc_insurance: '貨物保険',
  doc_export_decl: '輸出申告書',
  submit: '予約を申し込む',
  submitting: '送信中...',
  new_booking: '新しい予約をする',
  success_title: '予約を受け付けました',
  success_msg: 'ご予約内容を確認の上、担当者よりご連絡いたします。\n通常1〜2営業日以内にご返信いたします。',
  required_note: '* は必須項目です。ご予約確認後、担当者よりご連絡いたします（1〜2営業日）。',
  info_routes: '対応輸送ルート',
  info_routes_text: '中東・アフリカ・東南アジア\nヨーロッパ・北米など',
  info_hours: '営業時間',
  info_phone: 'お電話でのご相談',
};

export const login = {
  title: 'ログイン',
  subtitle: "N's Group Ltd. 管理画面",
  email: 'メールアドレス',
  emailPlaceholder: 'your@email.com',
  password: 'パスワード',
  passwordPlaceholder: 'パスワードを入力',
  submit: 'ログイン',
  loggingIn: 'ログイン中...',
  error: 'メールアドレスまたはパスワードが正しくありません',
  info: '管理者のみアクセス可能です',
  portal: 'メンバーポータル',
  tab_login: 'ログイン',
  tab_register: '新規登録',
  tab_admin: '管理者',
  forgot_password: 'パスワードをお忘れですか？',
  no_account: 'アカウントをお持ちでない方は',
  have_account: 'すでにアカウントをお持ちの方は',
  back_to_login: 'ログインに戻る',
  admin_title: '管理者ログイン',
  admin_subtitle: '管理者アカウントでログインしてください',
  admin_submit: '管理者としてログイン',
  admin_error: '管理者アカウントの認証に失敗しました',
  reg_name: 'お名前',
  reg_name_placeholder: '山田 太郎',
  reg_company: '会社名',
  reg_company_placeholder: '株式会社〇〇',
  reg_phone: '電話番号',
  reg_phone_placeholder: '+81 90-0000-0000',
  reg_email: 'メールアドレス',
  reg_password: 'パスワード',
  reg_password_hint: '6文字以上で入力してください',
  reg_password_placeholder: '6文字以上',
  reg_password_confirm: 'パスワード（確認）',
  reg_password_confirm_placeholder: 'もう一度入力してください',
  reg_submit: 'アカウントを作成',
  reg_submitting: '登録中...',
  reg_success_title: '登録が完了しました！',
  reg_success_msg: 'アカウントが作成されました。\nログインしてご利用ください。',
  reg_to_login: 'ログインページへ',
  reg_error_name: 'お名前を入力してください',
  reg_error_short: 'パスワードは6文字以上で入力してください',
  reg_error_mismatch: 'パスワードが一致しません',
  reg_error_exists: 'このメールアドレスはすでに登録されています',
  forgot_title: 'パスワードをお忘れですか？',
  forgot_subtitle: '登録済みのメールアドレスを入力してください。\nパスワードの再設定を行います。',
  forgot_submit: '次へ',
  forgot_checking: '確認中...',
  forgot_error: 'このメールアドレスは登録されていません',
  reset_title: '新しいパスワードを設定',
  reset_new_password: '新しいパスワード',
  reset_new_password_confirm: '新しいパスワード（確認）',
  reset_submit: 'パスワードを更新する',
  reset_updating: '更新中...',
  reset_success_title: 'パスワードを更新しました！',
  reset_success_msg: '新しいパスワードでログインしてください。',
  reset_to_login: 'ログインページへ',
  copyright: "© 2025 N's Group Ltd. All rights reserved.",
};

export const admin = {
  dashboard_label: '管理者ダッシュボード',
  title: '予約・問い合わせ管理',
  tab_shipping: '配送予約',
  tab_loading: '積込予約',
  tab_forwarding: 'フォワーディング予約',
  tab_contact: 'お問い合わせ',
  back_to_site: 'サイトへ戻る',
  logout: 'ログアウト',
  viewing: '表示中',
  count_unit: '件',
  refresh: '更新',
  loading: 'データを読み込み中...',
  fetch_error: 'データの取得に失敗しました。再度お試しください。',
  retry: '再試行',
  footer_note: 'このページは管理者専用です。データはReaddy フォームサービスから取得されます。',
  table: {
    detail_title: '詳細情報',
    received_at: '受付日時',
    reply_email: 'メールで返信',
    search_placeholder: '名前・会社名・メールで検索...',
    no_data: 'データがありません',
    filter_all: 'すべて',
    filter_unread: '未読',
    filter_read: '既読',
    mark_all_read: 'すべて既読にする',
    unread_count: '未読 {{count}}件',
    status_read: '既読',
    status_unread: '未読',
    fields: {
      shipping: {
        name: 'お名前',
        company: '会社名',
        email: 'メール',
        phone: '電話番号',
        cargo_type: '貨物種別',
        quantity: '数量',
        container_size: 'コンテナサイズ',
        destination: '仕向地',
        preferred_date: '希望積込日',
        alternative_date: '第2希望日',
        preferred_time: '希望時間帯',
        cy_cutoff: 'CY締め切り',
        notes: '備考',
      },
      loading: {
        name: 'お名前',
        company: '会社名',
        email: 'メール',
        phone: '電話番号',
        cargo_type: '積込品目',
        quantity: '数量',
        container_size: 'コンテナサイズ',
        container_number: 'コンテナ番号',
        destination: '仕向地',
        loading_method: '積込方法',
        preferred_date: '希望積込日',
        alternative_date: '第2希望日',
        preferred_time: '希望時間帯',
        cy_cutoff: 'CY締め切り',
        etd: '船積み予定日',
        loading_location: '積込場所',
        notes: '備考',
      },
      forwarding: {
        name: 'お名前',
        company: '会社名',
        email: 'メール',
        phone: '電話番号',
        service_type: 'サービス種別',
        cargo_type: '貨物種別',
        quantity: '数量',
        weight: '重量',
        port_of_loading: '積出港',
        port_of_discharge: '仕向港',
        customs_handling: '通関手続き',
        incoterms: 'インコタームズ',
        preferred_date: '希望出荷日',
        preferred_arrival: '希望到着日',
        notes: '備考',
      },
      contact: {
        name: 'お名前',
        company: '会社名',
        email: 'メール',
        phone: '電話番号',
        message: 'メッセージ',
      },
    },
  },
};

// About Page
export const aboutPage = {
  hero: {
    title: 'N\'s Group Ltd について',
    subtitle: '香港を拠点に、世界中のお客様に信頼されるコンテナバンニングサービスを提供しています。',
  },
  mission: {
    title: '私たちのミッション',
    description: 'N\'s Group Ltd は、お客様の貨物を安全かつ効率的に取り扱うことを使命としています。豊富な経験と専門知識を活かし、あらゆる業界のニーズに対応した高品質なコンテナバンニングサービスを提供します。',
  },
  values: {
    title: '私たちの価値観',
    quality: {
      title: '品質へのこだわり',
      description: '全ての作業において最高水準の品質を維持し、お客様の貨物を大切に扱います。',
    },
    efficiency: {
      title: '効率性',
      description: '迅速かつ正確な作業で、お客様の時間とコストを節約します。',
    },
    reliability: {
      title: '信頼性',
      description: '約束を守り、常にお客様の期待を超えるサービスを提供します。',
    },
    innovation: {
      title: '革新',
      description: '最新の技術と方法を取り入れ、常にサービスの向上を目指します。',
    },
  },
  team: {
    title: '経験豊富なチーム',
    description: '私たちのチームは、コンテナバンニングの専門家で構成されています。長年の経験と専門知識を持つスタッフが、お客様の貨物を安全に取り扱います。',
  },
  contact: {
    title: 'お問い合わせ',
    address: '住所',
    phone: '電話',
    email: 'メール',
    hours: '営業時間',
    hoursValue: '月曜日 - 金曜日: 9:00 - 18:00',
  },
};

// Services Page
export const servicesPage = {
  hero: {
    title: '私たちのサービス',
    subtitle: 'あらゆる業界のニーズに対応した、包括的なコンテナバンニングサービスを提供しています。',
  },
  list: {
    title: 'サービス一覧',
    containerVanning: {
      title: 'コンテナバンニング',
      description: '専門スタッフによる安全で効率的なコンテナ積込作業。あらゆるサイズ・種類の貨物に対応します。',
      features: ['20ft・40ft・40ft HCコンテナ対応', '専門スタッフによる作業', '貨物の安全確保', '効率的な積込'],
    },
    cargoInspection: {
      title: '貨物検査',
      description: '出荷前の徹底した品質チェックで、お客様の貨物が完璧な状態で届くことを保証します。',
      features: ['品質チェック', '数量確認', '損傷検査', '詳細レポート'],
    },
    warehousing: {
      title: '倉庫保管',
      description: '安全で清潔な倉庫施設で、お客様の貨物を大切に保管します。',
      features: ['24時間セキュリティ', '温度管理', '在庫管理システム', '短期・長期保管'],
    },
    customsClearance: {
      title: '通関サポート',
      description: '複雑な通関手続きをスムーズに進めるためのサポートを提供します。',
      features: ['書類作成支援', '通関手続き代行', '関税相談', '迅速な処理'],
    },
    packagingServices: {
      title: '梱包サービス',
      description: '貨物の種類に応じた適切な梱包で、輸送中の安全を確保します。',
      features: ['専門梱包材', 'カスタム梱包', '保護対策', '環境配慮'],
    },
    logisticsConsulting: {
      title: '物流コンサルティング',
      description: 'お客様のビジネスに最適な物流ソリューションを提案します。',
      features: ['コスト最適化', 'ルート提案', '効率化支援', '長期パートナーシップ'],
    },
  },
  booking: {
    title: '予約サービス',
    description: 'オンラインで簡単に予約できます。お客様のニーズに合わせたサービスをお選びください。',
    delivery: {
      title: '配送予約',
      description: '貨物の配送スケジュールを予約',
    },
    loading: {
      title: '積込予約',
      description: 'コンテナ積込作業を予約',
    },
    forwarding: {
      title: 'フォワーディング予約',
      description: '国際輸送サービスを予約',
    },
  },
  cta: {
    title: 'お見積もりが必要ですか？',
    description: 'お客様のニーズに合わせた最適なソリューションをご提案します。お気軽にお問い合わせください。',
    button: 'お問い合わせ',
  },
};

export const profile = {
  my_account: 'マイアカウント',
  hero_title: 'プロフィール設定',
  hero_subtitle: 'アカウント情報の確認・編集ができます',
  tab_profile: 'プロフィール',
  tab_password: 'パスワード変更',
  section_basic: '基本情報',
  section_password: 'パスワード変更',
  field_name: 'お名前',
  field_company: '会社名',
  field_phone: '電話番号',
  field_email: 'メールアドレス',
  field_address: '会社住所',
  email_readonly: 'メールアドレスは変更できません',
  placeholder_name: '山田 太郎',
  placeholder_company: '株式会社〇〇',
  placeholder_phone: '+81 90-0000-0000',
  placeholder_address: '例：東京都港区〇〇 1-2-3',
  avatar_upload: '写真をアップロード',
  avatar_delete: '写真を削除',
  avatar_hint: 'アバター画像をクリックして写真を変更できます',
  role_admin: '管理者',
  role_member: 'メンバー',
  back: '戻る',
  save: '変更を保存',
  saving: '保存中...',
  saved_profile: 'プロフィールを更新しました',
  error_name_required: 'お名前を入力してください',
  error_update_failed: '更新に失敗しました。再度お試しください。',
  field_current_password: '現在のパスワード',
  field_new_password: '新しいパスワード',
  field_confirm_password: '新しいパスワード（確認）',
  placeholder_current_password: '現在のパスワード',
  placeholder_new_password: '6文字以上',
  placeholder_confirm_password: 'もう一度入力してください',
  password_hint: '6文字以上で入力してください',
  update_password: 'パスワードを更新',
  updating_password: '更新中...',
  saved_password: 'パスワードを更新しました',
  error_wrong_password: '現在のパスワードが正しくありません',
  error_password_short: '新しいパスワードは6文字以上で入力してください',
  error_password_mismatch: 'パスワードが一致しません',
  image_size_error: '画像サイズは5MB以下にしてください',
};

export const transition = {
  login_verifying: '認証中...',
  login_complete: 'ログイン完了',
  login_welcome: 'ようこそ、',
  login_welcome_suffix: ' さん',
  logout_signing: 'サインアウト中...',
  logout_complete: 'ログアウト完了',
  logout_message: 'またのご利用をお待ちしております',
};
